import upload from "../../assets/landingPageItems/upload.svg";
import book from "../../assets/landingPageItems/book.svg";
import lock from "../../assets/landingPageItems/lock.svg";
import slash from "../../assets/landingPageItems/slash.svg";
import timer from "../../assets/landingPageItems/timer.svg";
import codeOff from "../../assets/landingPageItems/code-off.svg";
export default function Features() {
  const features = [
    {
      title: "Cross-Compatible Data Ingestion",
      description: "Import From Any POS Or E-Commerce Platform Seamlessly",
      icon: upload,
    },
    {
      title: "Bookkeeper-Ready Output",
      description:
        "Generate Clean, Organized Spreadsheets Ready For Accounting",
      icon: book,
    },
    {
      title: "Secure & Always Available",
      description: "Cloud-Native Platform With Enterprise-Grade Security",
      icon: lock,
    },
    {
      title: "No More Copy-Paste Errors",
      description:
        "Eliminate Manual Data Entry Mistakes With Automated Processing",
      icon: slash,
    },
    {
      title: "Save Hours Every Week",
      description: "Reduce Bookkeeping Time From Hours To Minutes",
      icon: timer,
    },
    {
      title: "No Code, No Formulas",
      description:
        "Simple Drag-And-Drop Interface With Zero Technical Knowledge Required",
      icon: codeOff,
    },
  ];


  return (
    <>
      <section id="features" className="bg-lightBlue text-white py-8 md:py-12  font-raleway">
        <div className="mx-auto text-center">
          <h2 className="text-4xl md:text-6xl font-audiowide text-white">
            Key <span className="text-lightGreen">Features</span>
          </h2>
          <p className="mt-4 md:mt-5 text-base md:text-lg text-gray-300">
            Everything You Need To Streamline Your Bookkeeping Process
          </p>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((item) => (
              <div
                key={item.title}
                className="border border-lightGreen rounded-xl p-6 bg-white bg-opacity-5  transition text-start"
              >
                <img
                  src={item.icon}
                  alt={item.title}
                  className="h-[60px] select-none"
                  draggable="false"
                />
                <h3 className="text-base md:text-lg font-semibold mb-1">
                  {item.title}
                </h3>
                <p className="text-sm md:text-base text-gray-300">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    
    </>
  );
}
